import { render, staticRenderFns } from "./WriteOff.vue?vue&type=template&id=28000d8c&scoped=true&"
import script from "./WriteOff.vue?vue&type=script&lang=js&"
export * from "./WriteOff.vue?vue&type=script&lang=js&"
import style0 from "./WriteOff.vue?vue&type=style&index=0&id=28000d8c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "28000d8c",
  null
  
)

export default component.exports